// SVG gradient for the green-to-blue accent; reference it as stroke={`url(#${id})`}.
const PopGradient = ({ id, x1, y1, x2, y2 }: { id: string; x1: number; y1: number; x2: number; y2: number }) => (
  <defs>
    <linearGradient id={id} gradientUnits="userSpaceOnUse" x1={x1} y1={y1} x2={x2} y2={y2}>
      <stop offset="0" style={{ stopColor: "rgb(var(--ax-live-start))" }} />
      <stop offset="1" style={{ stopColor: "rgb(var(--ax-live-end))" }} />
    </linearGradient>
  </defs>
);

export default PopGradient;
